var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("layout-1", {
        staticStyle: { width: "100%", height: "calc(100vh - 50px)" },
        attrs: {
          table_name: "Files",
          id: _vm.pageid,
          searchbar: false,
          navbar: false,
          button_perm: "67",
          button_name: "Download",
          term: _vm.term
        },
        on: { select: _vm.select }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "nav-bar" }, [
        _c(
          "button",
          {
            on: {
              click: function($event) {
                return _vm.addFile()
              }
            }
          },
          [_vm._v("Add File")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            on: {
              click: function($event) {
                return _vm.deleteFile()
              }
            }
          },
          [_vm._v("Delete File")]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4cb037c9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4cb037c9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/Job_Orders_Files.vue
// module id = 531
// module chunks = 0